import { BlockTitle } from "@blocks/Blocks";

/**
 * Component to render SIA contact us page
 */
const SIAContactUsPage = (): React.ReactElement => {
  return (
    <div
      data-testid="sia-contact-us-page-component"
      className="font-public-sans"
    >
      <BlockTitle
        text="Contact Us"
        rootClassName="my-3 text-3xl md:text-5xl lg:text-6xl font-medium font-public-sans"
      />

      <p className="mb-6">
        For nominations or more information on Sustainability Impact Awards
        2026, please contact:
      </p>

      <ul className="mb-6">
        <li>Lin Shaomei</li>
        <li>The Business Times</li>
        <li>1000 Toa Payoh North </li>
        <li>Podium Level 3, Singapore 318994</li>
      </ul>

      <ul className="mb-6">
        <li>
          Email:{" "}
          <a
            className="text-blue-175 hover:text-gray-750"
            href="mailto:smlin@sph.com.sg"
          >
            smlin@sph.com.sg
          </a>
        </li>
      </ul>
    </div>
  );
};
export default SIAContactUsPage;
